var map = {
	"./action_img.png": 123,
	"./background.png": 339,
	"./banner_shap.png": 340,
	"./cloud-computing.png": 341,
	"./cloud_01.png": 124,
	"./cloud_02.png": 125,
	"./cloud_03.png": 126,
	"./cloud_04.png": 127,
	"./cloud_05.png": 128,
	"./cloud_06.png": 129,
	"./crm_img1.jpg": 342,
	"./crm_img2.jpg": 343,
	"./crm_img3.jpg": 344,
	"./erp_dashboard.jpg": 130,
	"./erp_icon1.png": 345,
	"./erp_icon2.png": 346,
	"./erp_icon3.png": 347,
	"./erp_icon4.png": 348,
	"./erp_icon5.png": 349,
	"./erp_icon6.png": 350,
	"./growth.png": 351,
	"./img/01.png": 131,
	"./img/02.png": 132,
	"./img/03.png": 133,
	"./img/04.png": 134,
	"./img/05.png": 135,
	"./img/06.png": 136,
	"./img/07.png": 137,
	"./img/08.png": 138,
	"./img/09.png": 139,
	"./img/10.png": 140,
	"./img/11.png": 141,
	"./img/12.png": 142,
	"./img/13.png": 143,
	"./img/14.png": 144,
	"./img/15.png": 145,
	"./img/16.png": 146,
	"./img/17.png": 147,
	"./img/18.png": 148,
	"./img/19.png": 149,
	"./img/20.png": 150,
	"./quote.png": 352,
	"./rocket.png": 151,
	"./settings1.png": 353,
	"./shape.png": 354,
	"./testimonial_img.jpg": 355,
	"./testimonial_img2.jpg": 356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75;